import { render, staticRenderFns } from "./ContentGrid.vue?vue&type=template&id=a0916ec4&scoped=true&shadow"
import script from "./ContentGrid.vue?vue&type=script&lang=js&shadow"
export * from "./ContentGrid.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  var style0 = require("./ContentGrid.vue?vue&type=style&index=0&id=a0916ec4&lang=scss&scoped=true&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "a0916ec4",
  null
  ,true
)

export default component.exports